import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
}

export class ActivityEndPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(20)} />
                <Text style={styles.text}>活动已经结束了</Text>
                <Spacer size={rpx(25)} />
                <EmTouchableOpacity
                  activeOpacity={0.9}
                  onPress={() => {
                    onPress && onPress();
                  }}
                  style={styles.iKnow}
                >
                  <Image
                    source={require('../../images/invite/iKnow.png')}
                    style={styles.iKnow}
                    resizeMode={'stretch'}
                  />
                </EmTouchableOpacity>
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iKnow: { width: rpx(210), height: rpx(52) },
  main: {
    width: rpx(300),
    height: rpx(180),
    backgroundColor: '#fff',
    borderRadius: rpx(12),
    alignItems: 'center',
    justifyContent: 'center',
    padding: rpx(25),
    marginTop: -rpx(115 / 2),
  },
  text: {
    fontSize: rpx(23),
    color: '#333333',
    lineHeight: rpx(26),
  },
  cryImg: {
    width: rpx(115),
    height: rpx(115),
    zIndex: 11,
  },
  btnText: {
    fontSize: rpx(16),
    color: '#ffffff',
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
});
